import { TEDCustomDateTimeDisplayer } from './TEDCustomDateTimeDisplayer';
import { TEDParseDateTimeMode } from '../FormatterTypes';

class TEDDisplayDateYear extends TEDCustomDateTimeDisplayer {
  static instance: TEDDisplayDateYear;
  public static getInstance(): TEDDisplayDateYear {
    return this.instance ? this.instance : (this.instance = new this());
  }

  public mode() {
    return TEDParseDateTimeMode.pdmY;
  }
}

export { TEDDisplayDateYear };
